﻿import React, { useRef } from "react";
import { useContentStyles } from "./Content.styles";
import { ContentSizeProvider } from "./ContentSizeContext";
import DotLegalPlayer from "../../common/components/dotLegalPlayer/DotLegalPlayer";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useContentDataMapping } from "./Content.hooks";
import { Box } from "@mui/system";
import TrialSoonToExpireDialog from "../../plan/trialSoonToExpireDialog/TrialSoonToExpireDialog";
import TrialExpiredDialog from "../../plan/TrialExpiredDialog/TrialExpiredDialog.tsx";
import TrialRibbon from "../../trial/trialRibbon/TrialRibbon";
import { useTrialInformationHook } from "../../trial/TrialInformation.hooks";
import { usePlanContext } from "../../auth/planProvider/PlanProvider.tsx";
import OverviewOfTrialsDialog from "../../plan/overviewOfTrialsDialog/OverviewOfTrialsDialog.tsx";
import { isPdfRequest } from "../../common/pdfUrlHelper.ts";
import TopBar from "./topBar/TopBar.tsx";
import PublishedSystemNotificationDialog from "../publishedSystemNotificationDialog/PublishedSystemNotificationDialog.tsx";

export interface IContentProps {
    children: React.ReactElement;
}

function Content(props: IContentProps) {
    const styles = useContentStyles(isPdfRequest());
    const userContext = useUserContext();
    const { addonsFeatures } = usePlanContext();
    const { videoLink, showIntroVideo, setShowIntroVideo } = useContentDataMapping(userContext.isFirstLogin, addonsFeatures.research);
    const { isLoading, data, setShowOverviewOfTrialsDialog, showOverviewOfTrialsDialog } = useTrialInformationHook();
    const contentRef = useRef<HTMLDivElement>(null);

    return (
        <ContentSizeProvider contentRef={contentRef}>
            <Box sx={styles.wrapper}>
                <Box id={"top-bar-wrapper"} sx={{ position: "sticky", top: 0 + "px", zIndex: 1000 }}>
                    {!isLoading && data?.showTrialDialogs && (
                        <React.Fragment>
                            <TrialSoonToExpireDialog data={data} />
                            <TrialExpiredDialog data={data} />
                            <TrialRibbon onShowTrialsOverClick={() => setShowOverviewOfTrialsDialog(true)} data={data} />
                            {showOverviewOfTrialsDialog && (
                                <OverviewOfTrialsDialog
                                    plansOnTrials={data.plansOnTrials?.filter((x) => !x.isExpired) ?? []}
                                    onDialogClose={() => setShowOverviewOfTrialsDialog(false)}
                                />
                            )}
                        </React.Fragment>
                    )}
                    <TopBar />
                </Box>

                <Box ref={contentRef} sx={styles.content} id={"content-window"}>
                    {props.children}
                </Box>
                {showIntroVideo && <DotLegalPlayer url={videoLink!} onCloseDialog={() => setShowIntroVideo(false)} />}
                <PublishedSystemNotificationDialog />
            </Box>
        </ContentSizeProvider>
    );
}

export default Content;
